import React, { useContext } from 'react'
import DownloadHelper from './DownloadHelper';
import ModalRoot from './ModalRoot';
import LegacyDialogRoot from './LegacyDialogRoot';
import ContextMenuRoot from './ContextMenuRoot'
import { Provider } from 'react-redux';
import { notification } from 'antd';

const ReactRoot = ({store, $rootScope}) => {

  const notificationConfig =  {
    bottom: 25,
    duration: 4,
    placement: 'bottom',
  }

  notification.config(notificationConfig);

  // for angular
  window.dl.notification = notification;

    return(
      <Provider store={store}>
        <DownloadHelper store={store} $rootScope={$rootScope} />
        <ModalRoot store={store} $rootScope={$rootScope} />
        <LegacyDialogRoot store={store} $rootScope={$rootScope} />
        <ContextMenuRoot store={store} $rootScope={$rootScope} />
      </Provider>
  )
}

export default ReactRoot;